import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=f322e598&"
import script from "./PartnerCard.vue?vue&type=script&lang=js&"
export * from "./PartnerCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports